import {PodigeeWidget} from "@src/interfaces";
import React, {useCallback} from "react";

const PodigeeItem = (podigeeProps: PodigeeWidget) => {
  const measuredRef = useCallback(
    (node: HTMLDivElement) => {
      if (node !== null) {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src =
          'https://player.podigee-cdn.net/podcast-player/javascripts/podigee-podcast-player.js';
        script.setAttribute('data-configuration', podigeeProps.url);
        script.setAttribute('class', 'podigee-podcast-player');
        node.appendChild(script);
      }
    },
    [podigeeProps.url],
  );

  return (
    <section className="paragraph podigee-paragraph">
      {podigeeProps.title && <h3>{podigeeProps.title}</h3>}

      <div ref={measuredRef} />
    </section>
  );
};

export default PodigeeItem;
